import React, { useCallback, useState, useEffect, useRef } from 'react'
import moment from 'moment'
import { t } from 'i18next';
import '../../../services/scheduleService'
import { CommonDropDown } from '../../../common/Resusable/CommonDropDown';

const WeekSelector = ({
  saveExcelData,
  setStartDate,
  setEndDate,
  setWeekData,
  setMonth,
  month,
}) => {
  const [week, setWeek] = useState();
  const [weeks, setWeeks] = useState([]);
  const [months, setMonths] = useState([]);

  function getWeeks(month) {
    let day1 = `${month}-01`;
    const numberOfDaysMonth = moment(day1, 'YYYY-MMM-DD').daysInMonth()
    
    let weeks = []
    for (var i = 1; i <= numberOfDaysMonth; i = i + 6) {
      let dayStr = `${month}-` + i;
      if (i < 10) {
        dayStr = `${month}-` + '0' + i;
      }
      const today = moment(dayStr, 'YYYY-MMM-DD')
      const from_date = moment(today.startOf('week')).add(1, 'days')
      const to_date = moment(today.endOf('week')).add(1, 'days');
      const startWeek = `${from_date.format('DD')} ${from_date.format('MMM')}`
      const endWeek = `${to_date.format('DD')} ${to_date.format('MMM')}`

      const weekVal = {
        fromDate: from_date.format('DD-MMM-YYYY'),
        toDate: to_date.format('DD-MMM-YYYY')
      }
      const week = { label: `${startWeek} to ${endWeek}`, value: JSON.stringify(weekVal) }
      weeks.push(week)
    }
    const result = weeks.filter((obj, index) => {
      return index === weeks.findIndex(o => obj.value === o.value);
    });

    return result;
  }

  function getMonths() {
    let months = []
    for (let i = 0; i <= 12; i++) {
      let today = moment()
      const dateVar = today.add(i, "months");
      months.push({
        label: dateVar.format('MMMM yyyy'),
        value: dateVar.format('yyyy-MMM'),
      })
    }
    return months
  }


  const handleMonth = (month) => {
    setWeek('')
    setWeekData(null)
    setMonth(month)
    setWeeks(getWeeks(month))
  }

  const handleWeek = (val) => {
    const value = JSON.parse(val)
    setWeek(val)
    setWeekData(value)
    let startDateVal = moment(value.fromDate)
    startDateVal = startDateVal.subtract(1, "days");
    startDateVal = startDateVal.format("DD-MMM-YYYY");
    setStartDate(startDateVal)
    setEndDate(value.toDate)
  }

  useEffect(() => {
    let defaultDate = moment()
    let month = defaultDate.format('yyyy-MMM')

    setMonth(month)
    setWeeks(getWeeks(`${month < 10 ? '0' + month : month}`))
    setMonths(getMonths())
  }, [])

  return (
    <>
      <CommonDropDown
        label={t('SCHEDULE_VISUALIZATION.MONTH_LABEL')}
        value={month}
        options={months}
        onChange={(e) => {
          handleMonth(e.target.value)
        }}
        isUpdate={true}
      />
      <CommonDropDown
        label={t('SCHEDULE_VISUALIZATION.WEEK_LABEL')}
        value={week}
        options={weeks}
        onChange={(e) => {
          handleWeek(e.target.value)
        }}
        isUpdate={true}
      />
    </>
  )
}



export default WeekSelector
